import { FC } from "react";
import { Stack } from "@mui/material";
import { WidgetDateRangeWithInheritanceSwitcher } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/date-range/WidgetDateRangeWithInheritanceSwitcher";

interface BillingExplorerWidgetHeaderDateRangeFooterProps {
  inheritDates: boolean;
  onChange(checked: boolean): void;
}

export const WidgetHeaderDateRangeFooter: FC<
  BillingExplorerWidgetHeaderDateRangeFooterProps
> = ({ onChange, inheritDates }) => {
  return (
    <Stack py={1} pr={2} borderTop={1} borderColor="grey.300">
      <WidgetDateRangeWithInheritanceSwitcher
        inheritDates={inheritDates}
        onChange={onChange}
      />
    </Stack>
  );
};
